module.exports = __webpack_public_path__ + "img/search.d2c9cd8f.svg";